var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCasinoToto2124X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_casino_toto21_24x24",
    d: "M19.323,6.8,13.613,5.294a.918.918,0,0,0-1.178.622h0l-.816,3.021,1.45,5.242a1.426,1.426,0,0,1-.181,1.333,1.313,1.313,0,0,1-.453.533L16.6,17.2a.918.918,0,0,0,1.178-.622h0l2.356-8.53A1.257,1.257,0,0,0,19.323,6.8Zm-4.441,8.175L13.7,14.713l1.541-5.6-.906-.267.272-.8a1.167,1.167,0,0,0,1.541-.622l.634.267ZM8.538,5.294,2.829,6.8A.869.869,0,0,0,2.194,7.96h0l2.356,8.53a1.012,1.012,0,0,0,1.178.711h0l5.709-1.511a.99.99,0,0,0,.725-1.155h0L9.807,6c-.091-.533-.634-.8-1.269-.711Zm-1.269,8.8,2.175-.622.272,1.066-3.444.889L6,14.535c-.634-2.133,1.631-3.11,1.088-5.154,0-.711-.363-.8-.725-.711s-.544.355-.363.889l.272.8-1.178.267-.272-.711A1.709,1.709,0,0,1,6.091,7.6c1.178-.355,1.9.267,2.266,1.422.634,2.31-1.45,3.821-1.088,5.065-.091-.178,0-.089,0,0Z",
    transform: "translate(-2.138 -5.247)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCasinoToto2124X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_casino_toto21_24x24.f6968e2aedc2698e99b45fdb763f5b75.svg";